export namespace FlipBoard {
  export const FlipBoardModifierKey = 'x';

  export namespace Plugin {
    export const Name = 'flip-board';
  }
}
